import { useRef } from "react";
import { Tooltip } from "react-tooltip";
import { useDispatch } from "react-redux";
import { CircleCheck } from "lucide-react";
import { setModel, setRoof, setExterior, setInterior, setExtras, showRoof, setExtAccent, setIntAccent } from "../redux/roomSlice";

export default function Section({ id, className, title, element, multi }) {
    const parent = useRef(null);
    const container = useRef(null);
    const dispatch = useDispatch();

    function select(value) {
        for (let i = 0; i < container.current.children.length; i++) {
            const element = container.current.children[i];
            if (element.id == value) {
                if (multi) {
                    if (element.classList.contains("selected")) {
                        element.classList.remove("selected");
                    } 
                    else {
                        element.classList.add("selected");
                    }
                } 
                else {
                    element.classList.add("selected");
                }
            } 
            else if (!multi) {
                element.classList.remove("selected");
            }
        }
    }

    function getExtras() {
        let res = [];
        for (let i = 0; i < container.current.children.length; i++) {
            if (container.current.children[i].classList.contains("selected")) {
                res.push(container.current.children[i].id);
            }
        }
        return res;
    }

    function extAccentChanged() {
        const value = document.querySelector('input[name="extAccent"]:checked').parentElement.textContent;
        dispatch(setExtAccent(value));
    }

    function intAccentChanged() {
        const value = document.querySelector('input[name="intAccent"]:checked').parentElement.textContent;
        dispatch(setIntAccent(value));
    }

    return (
        <div id={id} className={className + " section"} ref={parent}>
            <h1>{title}</h1>
            <div ref={container} className="container">
                {element.elements.map((ele, index) => {
                    return (
                        <>
                            <Tooltip id={ele} place="bottom" content={ele}></Tooltip>
                            <div
                                id={index}
                                style={{
                                    background: element.previewTextures
                                        ? "url('/images/previews/" + element.previewTextures[index] + "')"
                                        : "",
                                }}
                                className={
                                    index == element.default ? "container-element selected" : "container-element"
                                }
                                onClick={() => {
                                    select(index);
                                    switch (title) {
                                        case "Modelo de vivienda":
                                            dispatch(setModel(ele));
                                            break;
                                        case "Cubierta":
                                            dispatch(setRoof(ele));
                                            dispatch(showRoof());
                                            break;
                                        case "Materiales de exterior":
                                            dispatch(setExterior(ele));
                                            break;
                                        case "Materiales de interior":
                                            dispatch(setInterior(ele));
                                            break;
                                        case "Extras":
                                            dispatch(setExtras(getExtras()));
                                            break;
                                    }
                                }}
                                data-tooltip-id={ele}
                            >
                                <CircleCheck color="#ffffff" strokeWidth={1.5} />
                                <p>{ele}</p>
                            </div>
                        </>
                    );
                })}
            </div>
            {title == "Materiales de exterior" && (
                <>
                    <h2>Acento</h2>
                    <label><input type="radio" name="extAccent" value="0" onChange={() => { extAccentChanged(); }} />Ninguno</label>
                    <label><input type="radio" name="extAccent" value="1" onChange={() => { extAccentChanged(); }} defaultChecked />Madera Roble Vintage</label>
                </>
            )}
            {title == "Materiales de interior" && (
                <>
                    <h2>Acento</h2>
                    <label><input type="radio" name="intAccent" value="0" onChange={() => { intAccentChanged(); }} defaultChecked />Ninguno</label>
                    <label><input type="radio" name="intAccent" value="1" onChange={() => { intAccentChanged(); }} />Porcelanico Gris</label>
                    <label><input type="radio" name="intAccent" value="2" onChange={() => { intAccentChanged(); }} />Porcelanico Antracita</label>
                    <label><input type="radio" name="intAccent" value="3" onChange={() => { intAccentChanged(); }} />Porcelanico Arena</label>
                </>
            )}
        </div>
    );
}
